export const WP_LOCALE = (document.documentElement.lang ?? 'en-GB').replace(
  '-',
  '_'
)

export type LocaleFallbackOption = 'none' | 'lang' | 'en' | 'any'
export type LocalizationOptions = {
  fallback?: LocaleFallbackOption
}

/** Get the matched locale inside of a localized object according to the system locale */
export function l(
  obj: Record<string, unknown> | undefined | null,
  options?: LocalizationOptions
) {
  const { fallback = 'lang' } = options ?? {}
  if (!obj || typeof obj !== 'object') return ''
  if (WP_LOCALE in obj) return WP_LOCALE
  if (fallback === 'none') {
    return ''
  }
  const lang = WP_LOCALE.split('_')[0] ?? 'en'
  for (const key in obj) {
    if (key.startsWith(lang)) return key
  }
  if (fallback === 'lang') {
    return ''
  }
  for (const key in obj) {
    if (key.startsWith('en')) return key
  }
  if (fallback === 'en') {
    return ''
  }
  return Object.keys(obj)[0] ?? ''
}

/** Translate the given object according to the system locale */
export function t(
  obj: Record<string, unknown> | string | undefined | null,
  options?: LocalizationOptions
) {
  if (!obj) return ''
  if (typeof obj === 'string') return obj
  return String(obj[l(obj, options)] ?? '')
}
